var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
import { Route } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
var Parent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  display: block;\n  font-weight: ", ";\n  padding: 0.7em 2em;\n\n  &.alwaysShadow {\n    box-shadow: ", ";\n\n    &.isOpen {\n      background-color: ", ";\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n  }\n\n  &:active {\n    background-color: ", ";\n    box-shadow: inset ", ";\n    transition: background-color 50ms ease-in, box-shadow 75ms ease-in;\n  }\n\n  &.active {\n    background-color: ", ";\n    border-left: 3px solid\n      ", ";\n    color: ", ";\n    box-shadow: ", ";\n    box-shadow: ", ";\n    transition: box-shadow 200ms ease-in-out, border 200ms ease-in-out;\n  }\n"], ["\n  color: ", ";\n  cursor: pointer;\n  display: block;\n  font-weight: ", ";\n  padding: 0.7em 2em;\n\n  &.alwaysShadow {\n    box-shadow: ", ";\n\n    &.isOpen {\n      background-color: ", ";\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n  }\n\n  &:active {\n    background-color: ", ";\n    box-shadow: inset ", ";\n    transition: background-color 50ms ease-in, box-shadow 75ms ease-in;\n  }\n\n  &.active {\n    background-color: ", ";\n    border-left: 3px solid\n      ", ";\n    color: ", ";\n    box-shadow: ", ";\n    box-shadow: ", ";\n    transition: box-shadow 200ms ease-in-out, border 200ms ease-in-out;\n  }\n"])), function (p) {
  return p.theme.textTertiary;
}, function (p) {
  return p.theme.fontWeightNormal;
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.textTertiary;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.boxShadowSmall;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.themeName === 'dark' ? p.theme.white : p.theme.themeName === 'greenlight' ? p.theme.white : p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.primary;
}, function (p) {
  return p.theme.themeName === 'dark' ? p.theme.white : p.theme.themeName === 'greenlight' ? p.theme.white : p.theme.textPrimary;
}, function (p) {
  return p.theme.boxShadowSmall;
}, function (p) {
  return p.theme.boxShadowSmall;
});
var ChildrenWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var Expander = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transform: ", ";\n  transition: transform 200ms ease-in-out;\n"], ["\n  transform: ", ";\n  transition: transform 200ms ease-in-out;\n"])), function (p) {
  return p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
});
var Flex = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));

var iconColor = function iconColor(p) {
  if (p.active) {
    if (p.theme.themeName === 'dark' || p.theme.themeName === 'greenlight') {
      return p.theme.white;
    } else if (p.theme.themeName === 'newlight') {
      return p.theme.primaryB;
    } else {
      return p.theme.primary;
    }
  } else {
    return p.theme.textTertiary;
  }
};

var Icon = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  margin-right: 0.5em;\n"], ["\n  color: ", ";\n  margin-right: 0.5em;\n"])), function (p) {
  return iconColor(p);
});

var NavParent = function NavParent(_a) {
  var icon = _a.icon,
      onClick = _a.onClick,
      isOpen = _a.isOpen,
      path = _a.path,
      title = _a.title,
      _b = _a.alwaysShadow,
      alwaysShadow = _b === void 0 ? false : _b;
  return (// eslint-disable-next-line react/no-children-prop
    React.createElement(Route, {
      path: path,
      children: function children(_a) {
        var match = _a.match;
        return React.createElement(Parent, {
          onClick: onClick,
          className: "nav-parent" + (match ? ' active' : '') + (isOpen ? ' isOpen' : '') + (alwaysShadow ? ' alwaysShadow' : '')
        }, React.createElement(ChildrenWrapper, null, React.createElement(Flex, null, icon && React.createElement(Icon, {
          className: "nav-icon",
          active: !!match
        }, React.createElement(FontAwesomeIcon, {
          icon: icon,
          fixedWidth: true
        })), title), React.createElement(Expander, {
          className: "nav-parent-expand",
          isOpen: isOpen
        }, React.createElement(FontAwesomeIcon, {
          icon: faAngleDown,
          fixedWidth: true
        }))));
      }
    })
  );
};

export default NavParent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;